<template>
  <v-tooltip bottom v-if="user">
    <template v-slot:activator="{ on, attrs }">
      <v-badge bordered overlap :content="badgeValue" :value="badgeVisible" :color="badgeColor" offset-x="25">
        <v-avatar
          v-bind="attrs"
          v-on="on"
          :class="['mp-avatar mx-3', { 'mp-avatar--placeholder': !user.avatar_url }]"
          :size="size"
          justify="center"
          v-if="user"
        >
          <v-img v-if="user.avatar_url" :src="user.avatar_url"></v-img>
          <v-icon v-else small>mdi-account</v-icon>
        </v-avatar>
      </v-badge>
    </template>
    <span>{{ user | userName }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "UserAvatar",
  props: {
    user: {
      type: Object,
      default: null
    },
    xsmall: Boolean,
    small: Boolean,
    large: Boolean,
    badgeColor: {
      type: String,
      default: "primary"
    },
    badgeValue: {
      type: Number,
      default: null
    },
    badgeVisible: {
      type: Boolean,
      default: false
    }

  },
  computed: {
    size() {
      if (this.large) {
        return "58px"
      } else if (this.small) {
        return "38px"
      } else if (this.xsmall) {
        return "24px"
      } else {
        return "48px"
      }
    }
  }
}
</script>

<style scoped>
.mp-avatar--placeholder {
  background: linear-gradient(135deg, #546e7a 0%, #37474f 100%);
}

.mp-avatar--placeholder .v-icon {
  color: #eceff1;
}
</style>